module.exports = "//cdn.scentbird.com/assets/frontbird-site/images/woman-mobile@2x_b96188.png";